<div class="control__wrapper bg-light">
    <div [ngClass]="{ 'control__shadow': elementVal.duringChange === 't' }"></div>
    <img class="control__img bg-style border-light"
        [ngClass]="{ 'bg-inactive': elementVal.duringChange === 't',
            'bg-style': elementVal.duringChange === 'f',
            'bg-style__icon': elementVal.duringChange === 'f' }"
        ngSrc="{{ setIcon(elementVal.iconId) }}"
        width="72" height="72" alt="" />
    <h2 class="control__title"
        [ngClass]="{ 'bg-inactive': elementVal.duringChange === 't',
            'bg-style': elementVal.duringChange === 'f',
            'bg-style__label': elementVal.duringChange === 'f' }">
        {{ subtitle(elementVal.txtId) }}
    </h2>
    <div class=" control__arrows heatingCurve">
        <img ngSrc="/assets/img/icons/arrows.svg"
            width="40" height="40" alt="" />
    </div>

    <div class="control__content heating-curve position-relative"
        data-testid="heating-curve">
        <div class="heating-curve__wrapper">
            <div class="heating-curve__temp">
                <p class="heating-curve__temp-title color-basic font-12">
                    {{ subtitle(768) }}
                </p>
                <div class="heating-curve__temp-items">
                    @for (val of heatingCurve.heatingCurveTable; track $index) {
                        @if (elementVal.params.points[$index].position !== null) {
                            <p class="heating-curve__temp-item color-basic font-12 position-absolute"
                                 [ngStyle]="{ 'left.px': $index === 0
                                    ? 800 / (elementVal.params.points.length+1) + 70
                                    : (800 / (elementVal.params.points.length+1)) * ($index + 1) + 70 }">
                                {{ val.position | format: elementVal.type === 30 ? 6 : elementVal.params.unit }}
                            </p>
                        }
                    }
                </div>
            </div>
            <div class="heating-curve__canvas">
                <canvas id="canvas" class="border-dark"></canvas>
                @for (_ of heatingCurve.heatingCurveTable; track $index) {
                    @if (elementVal.params.points[$index].position !== null) {
                            <div class="heating-curve__canvas-column heating-curve__canvas-column--{{ $index + 1 }} bg-grey"
                            [ngStyle]="{ 'left.px': $index === 0
                                ? 800 / (elementVal.params.points.length+1) + 79 - 25
                                : (800 / (elementVal.params.points.length+1)) * ($index + 1) + 79 - 25 }">
                        </div>
                        <div class="heating-curve__canvas-column heating-curve__canvas-column--{{ $index + 1 }}
                            cursor-pointer custom-slider"
                            [ngStyle]="{ 'left.px': $index === 0
                                ? 800 / (elementVal.params.points.length+1) + 79 - 25
                                : (800 / (elementVal.params.points.length+1)) * ($index + 1) + 79 - 25 }"
                            [attr.data-testid]="'slider-' + $index">
                            <ngx-slider
                                    [(value)]="values[$index]"
                                    [options]="options"
                                    (userChange)="heatingCurve.setHeatingCurveTouch($index, $event)"
                                    (userChangeEnd)="heatingCurve.setHeatingCurveTouch($index, $event)">
                            </ngx-slider>
                        </div>
                    }
                }
            </div>
            <div [ngClass]="{ 'heating-curve__group-btn': elementVal.params.points[0].position === -20,
                'heating-curve__group-btn-smaller-size': elementVal.params.points[0].position !== -20 }" >
                @for (_ of heatingCurve.heatingCurveTable; track $index) {
                    @if (elementVal.params.points[$index].position !== null) {
                        <div class="heating-curve__btn cursor-pointer position-absolute"
                             [ngStyle]="{ 'left.px': $index === 0
                                ? 800 / (elementVal.params.points.length+1) + (elementVal.type === 28 ? 40 : 25)
                                : (800 / (elementVal.params.points.length+1))*($index+1) + (elementVal.type === 28 ? 40 : 25)}">
                            <div class="heating-curve__arrow"
                                [attr.data-testid]="'minusButton-' + $index">
                                <hold-wrapper (onAction)="heatingCurve.setHeatingCurve($index, 'minus')">
                                    <img [ngClass]="{ 'heating-curve__arrow-img--small': elementVal.type === 28,
                                            'heating-curve__arrow-img': elementVal.type === 30 }"
                                         ngSrc="/assets/img/icons/minus.svg"
                                         width="{{ elementVal.type === 30 ? 40 : 35}}"
                                         height="{{ elementVal.type === 30 ? 40 : 35}}" alt="" />
                                </hold-wrapper>
                            </div>
                            <div class="heating-curve__arrow"
                                 [attr.data-testid]="'plusButton-' + $index">
                                <hold-wrapper (onAction)="heatingCurve.setHeatingCurve($index, 'plus')">
                                    <img [ngClass]="{ 'heating-curve__arrow-img--small': elementVal.type === 28,
                                            'heating-curve__arrow-img': elementVal.type === 30 }"
                                         ngSrc="/assets/img/icons/plus.svg"
                                         width="{{ elementVal.type === 30 ? 40 : 35}}"
                                         height="{{ elementVal.type === 30 ? 40 : 35}}" alt="" />
                                </hold-wrapper>
                            </div>
                        </div>
                    }
                }
            </div>
        </div>
    </div>
    <div class="control__group-btn">
        <button class="control__button bg-default bg-default__button control__button--shadow-active"
            data-testid="goBackButton"
            (click)="control.hideControl()">
            <img class="control__button-img"
                ngSrc="/assets/img/zone_icons/back.svg"
                width="40" height="40" alt="" />
        </button>
        <button class="control__button control__button--small bg-default"
            data-testid="resetButton"
            (click)="heatingCurve.setDefaultHeatingCurve(); setSlider();">
            <img class="control__button-img"
                 ngSrc="/assets/img/icons/return.svg"
                 width="40" height="40" alt="" />
        </button>
        <button class="control__button"
            [ngClass]="{ 'bg-default': elementVal.duringChange === 't',
                'bg-ok': elementVal.duringChange === 'f',
                'bg-ok--accept': elementVal.duringChange === 'f' }"
                data-testid="sendButton"
                (click)="heatingCurve.returnHeatingCurve()">
            <img class="control__button-img"
                 ngSrc="/assets/img/icons/ok.svg"
                 width="40" height="40" alt="" />
        </button>
    </div>
    @if (elementVal.duringChange === 't') {
        <div class="control__during-change">
            <p class="color-alarm font-18">{{ subtitle(3162) }}</p>
        </div>
    }
</div>
